import React, { Component, Fragment } from 'react'
import { Typography, Grid, TextField, FormControl, InputLabel, MenuItem, Select, Divider, Box, Button, FormHelperText, FormControlLabel, Checkbox, Tooltip } from '@material-ui/core'
import Crop from '../model/crop';
import ApplicationValue from '../model/application-value';
import { FieldDiscreteValues } from '../model/field-discrete-value';

interface ICultProps {
    key: any;
    disabled: boolean | undefined;
    onDataChange: any;
    onDelete: any;
    data: Crop;
    index: any;
    numberOfCrops: any;
    errors: string[];
    crops: string[];
}

export class CropComponent extends Component<ICultProps, any> {

    labels = new Map<string, React.RefObject<HTMLLabelElement>>();

    constructor(props: ICultProps) {
        super(props);

        var form: any = props.data;
        this.state = {
            form: form,
            crops: props.crops ? props.crops : [],
            errors: props.errors ? props.errors : []
        };

        this.labels.set('cropType', React.createRef<HTMLLabelElement>());
        this.labels.set('soilClass', React.createRef<HTMLLabelElement>());
        this.labels.set('soilCategory', React.createRef<HTMLLabelElement>());
        this.labels.set('occurrence', React.createRef<HTMLLabelElement>());
        this.labels.set('udzial_wlasny', React.createRef<HTMLLabelElement>());
        this.labels.set('minimalna_wysokosc_szkody', React.createRef<HTMLLabelElement>());

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange = (event: any) => {
        this.setState({
            form: Object.assign(this.state.form,
                { [event.target.name]: event.target.value }
            )
        });
    }

    handleNumberChange = (event: any) => {
        let val = event.target.value.replace(/\s+/g, '');
        val = val.replace(/,/, '.');

        this.setState({
            form: Object.assign(this.state.form,
                { [event.target.name]: val }
            )
        });
    }

    handleSelectionChange = (event: any) => {
        this.setState({
            form: Object.assign(this.state.form,
                { [event.target.name]: event.target.value.toString() }
            ),
            [event.target.name + '_label_width']: this.labels.get(event.target.name)?.current!.offsetWidth
        });
    }

    handleCoverageChange = (event: any) => {
        let crop = this.state.form as Crop;
        let av: ApplicationValue | undefined;
        av = crop.insuranceCoverage.find(p => p.key === event.target.name);

        if (event.target.checked) {

            let selectedIndex = event.target.value;
            let value = FieldDiscreteValues.find((e) => e.name === event.target.name).value;

            if (av === undefined) {
                av = new ApplicationValue(event.target.name, value, selectedIndex);
                crop.insuranceCoverage.push(av);
            } else {
                av.selectedIndex = selectedIndex;
                av.value = value;
            }

        } else {
            if (av) {
                let index = crop.insuranceCoverage.indexOf(av);
                crop.insuranceCoverage.splice(index, 1);
            }
        }

        this.setState({
            form: crop
        });
    }

    handleCoverageSelectionChange = (event: any) => {
        let crop = this.state.form as Crop;
        let av: ApplicationValue | undefined;
        av = crop.insuranceCoverage.find(p => p.key === event.target.name);


        let selectedIndex = event.target.value;
        let value = FieldDiscreteValues.find((e) => e.name.startsWith(event.target.name) && e.sortOrder === selectedIndex).value;

        if (av === undefined) {
            av = new ApplicationValue(event.target.name, value, selectedIndex);
            crop.insuranceCoverage.push(av);
        } else {
            av.selectedIndex = selectedIndex;
            av.value = value;
        }

        this.setState({
            form: crop,
            [event.target.name + '_label_width']: this.labels.get(event.target.name)?.current!.offsetWidth
        });
    }

    hasError = (fieldName: string): boolean => {
        return (this.state.errors as string[]).findIndex(p => p.startsWith(fieldName)) >= 0;
    }

    delete = (event: any) => {
        this.props.onDelete(this.state.form.id);
    }

    getValue = (key: string): string => {
        let av = (this.state.form as Crop).insuranceCoverage.find(p => p.key === key);
        return av ? av.value : '';
    }

    getSelectedIndex = (key: string): string => {
        let av = (this.state.form as Crop).insuranceCoverage.find(p => p.key === key);
        return av && av.selectedIndex != null ? av.selectedIndex.toString() : '';
    }

    render() {

        return (
            <Fragment>
                <Grid container spacing={2}>
                    <Grid item xs={6} sm={6}>
                        <Box>
                            <Typography variant="h6" align="left" gutterBottom={true}>Uprawa {this.props.index + 1}</Typography>
                        </Box>
                    </Grid>
                    <Grid container item xs={6} sm={6} alignItems="flex-end" justify="flex-end">
                        {this.props.numberOfCrops > 1 ?
                            <Button variant="text" color="secondary" onClick={this.delete}>Usuń</Button>
                            : null}
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormControl error={this.hasError("cropType")} variant="outlined" fullWidth>
                            <InputLabel ref={this.labels.get('cropType')} id="cropType_label">Rodzaj uprawy</InputLabel>
                            <Select disabled={this.props.disabled}
                                labelId="cropType_label"
                                id="cropType"
                                name="cropType"
                                value={this.state.form.cropType}
                                onChange={this.handleSelectionChange}
                                labelWidth={this.state.cropType_label_width}
                            >
                                {
                                    this.state.crops ? this.state.crops.map((crop: string, index: any) =>
                                        (
                                            <MenuItem key={index} value={crop}>{crop}</MenuItem>
                                        )
                                    ) : null
                                }
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField error={this.hasError("cropName")} disabled={this.props.disabled} id="cropName" label="Odmiana" name="cropName"
                            value={this.state.form.cropName} variant="outlined" margin="normal" required fullWidth onChange={this.handleChange}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <TextField error={this.hasError("voivodeship")} disabled={this.props.disabled} id="voivodeship" label="Województwo" name="voivodeship"
                            value={this.state.form.voivodeship} variant="outlined" margin="normal" required fullWidth onChange={this.handleChange}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <TextField error={this.hasError("district")} disabled={this.props.disabled} id="district" label="Powiat" name="district"
                            value={this.state.form.district} variant="outlined" margin="normal" required fullWidth onChange={this.handleChange}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <TextField error={this.hasError("commune")} disabled={this.props.disabled} id="commune" label="Gmina" name="commune"
                            value={this.state.form.commune} variant="outlined" margin="normal" required fullWidth onChange={this.handleChange}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField error={this.hasError("precinct")} disabled={this.props.disabled} id="precinct" label="Obręb" name="precinct"
                            value={this.state.form.precinct} variant="outlined" margin="normal" required fullWidth onChange={this.handleChange}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField error={this.hasError("parcelNumber")} disabled={this.props.disabled} id="parcelNumber" label="Numery ewidencyjne działek" name="parcelNumber"
                            value={this.state.form.parcelNumber} variant="outlined" margin="normal" required fullWidth onChange={this.handleChange}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <FormControl error={this.hasError("occurrence")} variant="outlined" fullWidth>
                            <InputLabel ref={this.labels.get('occurrence')} id="occurrence_label">Występowanie uprawy na działce</InputLabel>
                            <Select disabled={this.props.disabled}
                                labelId="occurrence_label"
                                id="occurrence"
                                name="occurrence"
                                value={this.state.form.occurrence}
                                onChange={this.handleSelectionChange}
                                labelWidth={this.state.occurrence_label_width}
                            >
                                <MenuItem value="na całej">na całej</MenuItem>
                                <MenuItem value="na części">na części</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <FormControl error={this.hasError("soilClass")} variant="outlined" fullWidth>
                            <InputLabel ref={this.labels.get('soilClass')} id="soilClass_label">Dominujaca klasa gleby</InputLabel>
                            <Select disabled={this.props.disabled}
                                labelId="soilClass_label"
                                id="soilClass"
                                name="soilClass"
                                value={this.state.form.soilClass}
                                onChange={this.handleSelectionChange}
                                labelWidth={this.state.soilClass_label_width}
                            >
                                <MenuItem value="kl I">kl I</MenuItem>
                                <MenuItem value="kl II">kl II</MenuItem>
                                <MenuItem value="kl IIIa">kl IIIa</MenuItem>
                                <MenuItem value="kl IIIb">kl IIIb</MenuItem>
                                <MenuItem value="kl IVa">kl IVa</MenuItem>
                                <MenuItem value="kl IVb">kl IVb</MenuItem>
                                <MenuItem value="kl V">kl V</MenuItem>
                                <MenuItem value="kl VI">kl VI</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <FormControl error={this.hasError("soilCategory")} variant="outlined" fullWidth>
                            <InputLabel ref={this.labels.get('soilCategory')} id="soilCategory_label">Kategoria gleby</InputLabel>
                            <Select disabled={this.props.disabled}
                                labelId="soilCategory_label"
                                id="soilCategory"
                                name="soilCategory"
                                value={this.state.form.soilCategory}
                                onChange={this.handleSelectionChange}
                                labelWidth={this.state.soilCategory_label_width}
                            >
                                <MenuItem value="Kategoria I">Kategoria I</MenuItem>
                                <MenuItem value="Kategoria II">Kategoria II</MenuItem>
                                <MenuItem value="Kategoria III">Kategoria III</MenuItem>
                                <MenuItem value="Kategoria IV">Kategoria IV</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField error={this.hasError("area")} disabled={this.props.disabled} id="area" label="Powierzchnia w ha" name="area"
                            value={this.state.form.area > 0 ? this.state.form.area.replace(/\./g, ',') : ''} variant="outlined" margin="normal" required fullWidth onChange={this.handleNumberChange}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField error={this.hasError("estimatedEfficiency")} disabled={this.props.disabled} id="estimatedEfficiency" label="Przewidywana wydajnośc w dt/ha" name="estimatedEfficiency"
                            value={this.state.form.estimatedEfficiency > 0 ? this.state.form.estimatedEfficiency.replace(/\./g, ',') : ''} variant="outlined" margin="normal" required fullWidth onChange={this.handleNumberChange}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField error={this.hasError("estimatedPrice")} disabled={this.props.disabled} id="estimatedPrice" label="Przewidywana cena w zł/dt" name="estimatedPrice"
                            value={this.state.form.estimatedPrice > 0 ? this.state.form.estimatedPrice.replace(/\./g, ',') : ''} variant="outlined" margin="normal" required fullWidth onChange={this.handleNumberChange}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField error={this.hasError("casting")} disabled={this.props.disabled} id="casting" label="Obsada w szt/m2" name="casting"
                            value={this.state.form.casting > 0 ? this.state.form.casting.replace(/\./g, ',') : ''} variant="outlined" margin="normal" required fullWidth onChange={this.handleNumberChange}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField error={this.hasError("leafAmount")} disabled={this.props.disabled} id="leafAmount" label="Ilość liści na jednej roślinie" name="leafAmount"
                            value={this.state.form.leafAmount > 0 ? this.state.form.leafAmount : ''} variant="outlined" margin="normal" required fullWidth onChange={this.handleChange}
                        />
                    </Grid>
                </Grid>



                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12}>
                        <Box pt={2}>
                            <Typography variant="h6" align="left">Zakres ubezpieczenia</Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormHelperText error={this.hasError('zakres_ubezpieczenia')}>
                            <FormControlLabel
                                control={<Checkbox disabled={this.props.disabled} id="zakres_ubezpieczenia_grad" name="zakres_ubezpieczenia_grad" checked={this.getValue('zakres_ubezpieczenia_grad') === 'true'} onChange={this.handleCoverageChange} value="0" />}
                                label="grad"
                                value="start" labelPlacement="end" className="checkboxLabel"
                            />
                        </FormHelperText>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormHelperText error={this.hasError('zakres_ubezpieczenia')}>
                            <FormControlLabel
                                control={<Checkbox disabled={this.props.disabled} id="zakres_ubezpieczenia_przymrozki" name="zakres_ubezpieczenia_przymrozki" checked={this.getValue('zakres_ubezpieczenia_przymrozki') === 'true'} onChange={this.handleCoverageChange} value="1" />}
                                label="przymrozki wiosenne"
                                value="start" labelPlacement="end" className="checkboxLabel"
                            />
                        </FormHelperText>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormHelperText error={this.hasError('zakres_ubezpieczenia')}>
                            <FormControlLabel
                                control={<Checkbox disabled={this.props.disabled} id="zakres_ubezpieczenia_deszcz" name="zakres_ubezpieczenia_deszcz" checked={this.getValue('zakres_ubezpieczenia_deszcz') === 'true'} onChange={this.handleCoverageChange} value="2" />}
                                label="deszcz nawalny"
                                value="start" labelPlacement="end" className="checkboxLabel"
                            />
                        </FormHelperText>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormHelperText error={this.hasError('zakres_ubezpieczenia')}>
                            <FormControlLabel
                                control={<Checkbox disabled={this.props.disabled} id="zakres_ubezpieczenia_huragan" name="zakres_ubezpieczenia_huragan" checked={this.getValue('zakres_ubezpieczenia_huragan') === 'true'} onChange={this.handleCoverageChange} value="3" />}
                                label="huragan"
                                value="start" labelPlacement="end" className="checkboxLabel"
                            />
                        </FormHelperText>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormHelperText error={this.hasError('zakres_ubezpieczenia')}>
                            <FormControlLabel
                                control={<Checkbox disabled={this.props.disabled} id="zakres_ubezpieczenia_ogien" name="zakres_ubezpieczenia_ogien" checked={this.getValue('zakres_ubezpieczenia_ogien') === 'true'} onChange={this.handleCoverageChange} value="4" />}
                                label="ogień"
                                value="start" labelPlacement="end" className="checkboxLabel"
                            />
                        </FormHelperText>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormHelperText error={this.hasError('zakres_ubezpieczenia')}>
                            <FormControlLabel
                                control={<Checkbox disabled={this.props.disabled} id="zakres_ubezpieczenia_piorun" name="zakres_ubezpieczenia_piorun" checked={this.getValue('zakres_ubezpieczenia_piorun') === 'true'} onChange={this.handleCoverageChange} value="5" />}
                                label="piorun"
                                value="start" labelPlacement="end" className="checkboxLabel"
                            />
                        </FormHelperText>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormHelperText error={this.hasError('zakres_ubezpieczenia')}>
                            <FormControlLabel
                                control={<Checkbox disabled={this.props.disabled} id="zakres_ubezpieczenia_obsuniecie_ziemi" name="zakres_ubezpieczenia_obsuniecie_ziemi" checked={this.getValue('zakres_ubezpieczenia_obsuniecie_ziemi') === 'true'} onChange={this.handleCoverageChange} value="6" />}
                                label="obsunięcie się ziemi"
                                value="start" labelPlacement="end" className="checkboxLabel"
                            />
                        </FormHelperText>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormHelperText error={this.hasError('zakres_ubezpieczenia')}>
                            <FormControlLabel
                                control={<Checkbox disabled={this.props.disabled} id="zakres_ubezpieczenia_lawina" name="zakres_ubezpieczenia_lawina" checked={this.getValue('zakres_ubezpieczenia_lawina') === 'true'} onChange={this.handleCoverageChange} value="7" />}
                                label="lawina"
                                value="start" labelPlacement="end" className="checkboxLabel"
                            />
                        </FormHelperText>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormHelperText error={this.hasError('zakres_ubezpieczenia')}>
                            <FormControlLabel
                                control={<Checkbox disabled={this.props.disabled} id="zakres_ubezpieczenia_powodz" name="zakres_ubezpieczenia_powodz" checked={this.getValue('zakres_ubezpieczenia_powodz') === 'true'} onChange={this.handleCoverageChange} value="8" />}
                                label="powódź"
                                value="start" labelPlacement="end" className="checkboxLabel"
                            />
                        </FormHelperText>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormHelperText error={this.hasError('zakres_ubezpieczenia')}>
                            <FormControlLabel
                                control={<Checkbox disabled={this.props.disabled} id="zakres_ubezpieczenia_susza" name="zakres_ubezpieczenia_susza" checked={this.getValue('zakres_ubezpieczenia_susza') === 'true'} onChange={this.handleCoverageChange} value="9" />}
                                label="susza"
                                value="start" labelPlacement="end" className="checkboxLabel"
                            />
                        </FormHelperText>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <FormHelperText error={this.hasError('zakres_ubezpieczenia')}>
                            <FormControlLabel
                                control={<Checkbox disabled={this.props.disabled} id="zakres_ubezpieczenia_skutki_zlego_przezimowania" name="zakres_ubezpieczenia_skutki_zlego_przezimowania" checked={this.getValue('zakres_ubezpieczenia_skutki_zlego_przezimowania') === 'true'} onChange={this.handleCoverageChange} value="10" />}
                                label="skutki złego przezimowania"
                                value="start" labelPlacement="end" className="checkboxLabel"
                            />
                        </FormHelperText>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <Tooltip title="Udział własny jest to określona w umowie ubezpieczenia część wartości szkody, jaką Ubezpieczony (gospodarz uprawniony do odbioru odszkodowania) zobowiązuje się pokryć z własnych środków." placement="top-start">
                            <FormControl error={this.hasError('udzial_wlasny')} variant="outlined" fullWidth>
                                <InputLabel ref={this.labels.get('udzial_wlasny')} id="udzial_wlasny_label">Zniesienie udziału własnego</InputLabel>
                                <Select disabled={this.props.disabled}
                                    labelId="udzial_wlasny_label"
                                    id="udzial_wlasny"
                                    name="udzial_wlasny"
                                    value={this.getSelectedIndex('udzial_wlasny')}
                                    onChange={this.handleCoverageSelectionChange}
                                    labelWidth={this.state.udzial_wlasny_label_width}
                                >
                                    <MenuItem value={0}>Tak</MenuItem>
                                    <MenuItem value={1}>Nie</MenuItem>
                                </Select>
                            </FormControl>
                        </Tooltip>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <Tooltip title="Franszyza integralna to kwota, do wysokości której ubezpieczyciel nie odpowiada za powstałą szkodę. Jeżeli jednak wartość szkody przekroczy tę kwotę, wówczas ubezpieczyciel wypłaca całe należne odszkodowanie." placement="top-start">
                            <FormControl error={this.hasError('minimalna_wysokosc_szkody')} variant="outlined" fullWidth>
                                <InputLabel ref={this.labels.get('minimalna_wysokosc_szkody')} id="minimalna_wysokosc_szkody_label">Minimalna wysokośc szkody (franszyza integralna)</InputLabel>
                                <Select disabled={this.props.disabled}
                                    labelId="minimalna_wysokosc_szkody_label"
                                    id="minimalna_wysokosc_szkody"
                                    name="minimalna_wysokosc_szkody"
                                    value={this.getSelectedIndex('minimalna_wysokosc_szkody')}
                                    onChange={this.handleCoverageSelectionChange}
                                    labelWidth={this.state.minimalna_wysokosc_szkody_label_width}
                                >
                                    <MenuItem value={0}>10%</MenuItem>
                                    <MenuItem value={1}>8%</MenuItem>
                                </Select>
                            </FormControl>
                        </Tooltip>
                    </Grid>

                </Grid>

                <Typography variant="h5" gutterBottom={true}>&nbsp;</Typography>
                <Divider />
                <Typography variant="h5" gutterBottom={true}>&nbsp;</Typography>
            </Fragment>
        )
    }

}
